import { call, put, select } from 'redux-saga/effects';

import { goToFactoryService, goToRootService } from './router';
import {
  createFactoryRequest,
  deleteFactoryRequest,
  updateFactoryBackgroundImageRequest,
  updateFactoryRequest,
} from '../requests';
import { pathSelector } from '../../../selectors';
import { createFactory, deleteFactory, updateFactory } from '../../../actions';

export function* createFactoryService(data) {
  yield put(createFactory(data));

  const {
    success,
    payload: { factory },
  } = yield call(createFactoryRequest, data);

  if (success) {
    yield call(goToFactoryService, factory.id);
  }
}

export function* updateFactoryService(id, data) {
  yield put(updateFactory(id, data));
  yield call(updateFactoryRequest, id, data);
}

export function* updateCurrentFactoryService(data) {
  const { factoryId } = yield select(pathSelector);

  yield call(updateFactoryService, factoryId, data);
}

export function* updateFactoryBackgroundImageService(id, data) {
  yield call(updateFactoryBackgroundImageRequest, id, data);
}

export function* updateCurrentFactoryBackgroundImageService(data) {
  const { factoryId } = yield select(pathSelector);

  yield call(updateFactoryBackgroundImageService, factoryId, data);
}

export function* deleteFactoryService(id) {
  const { factoryId } = yield select(pathSelector);

  if (id === factoryId) {
    yield call(goToRootService);
  }

  yield put(deleteFactory(id));
  yield call(deleteFactoryRequest, id);
}

export function* deleteCurrentFactoryService() {
  const { factoryId } = yield select(pathSelector);

  yield call(deleteFactoryService, factoryId);
}
